import React from 'react'
import PropTypes from 'prop-types'

let SimpleFormat = props => {
  let paragraphs = props.text.split('\n')

  let formattedText = paragraphs.map((paragraph, idx) => {
    return <p key={idx}>{paragraph.replace(/&#10;/g, '<br />').trim()}</p>
  })

  return <div>{formattedText}</div>
}

SimpleFormat.defaultProps = {
  text: ''
}

SimpleFormat.propTypes = {
  text: PropTypes.string
}

export default SimpleFormat
